import { faEdit } from '~components/icon';
import { Column, Row } from '~components/table-view-v3';
import { linkCellRender } from '~components/table-view-v3/columnRenderers';

import ActionButtons from './ActionButtons';
import ClaimStatusBadge from './ClaimStatusBadge';
import StatusBadge from './StatusBadge';

const getRequiresSeniorApproval = (row: Row, limit: number) => (row.gross_total ?? 0) >= limit;

export const columnsFactory = (openInvoiceModal: (id: string) => void, seniorApprovalLimit: number): Column[] => {
  const columns: Column[] = [
    {
      id: 'reference',
      header: 'Invoice Reference',
      type: 'text',
      renderReadOnly: linkCellRender((row) => openInvoiceModal(String(row.id)), faEdit),
    },
    {
      id: 'client',
      header: 'Client Name',
      type: 'text',
      deriveValue: (row) => row?.client?.full_name || '',
    },
    {
      id: 'supplier',
      header: 'Supplier',
      type: 'text',
      deriveValue: (row) => row?.supplier?.name || '',
    },
    {
      id: 'invoice_date',
      header: 'Invoice Date',
      type: 'date',
    },

    {
      id: 'due_date',
      header: 'Due Date',
      type: 'date',
    },
    {
      id: 'net_total',
      header: 'Net',
      type: 'currency',
      classNames: {
        header: 'cell-align-right',
        column: 'cell-align-right',
      },
    },
    {
      id: 'gross_total',
      header: 'Gross',
      type: 'currency',
      classNames: {
        header: 'cell-align-right',
        column: 'cell-align-right',
      },
    },
    {
      id: 'requires_senior_approval',
      header: 'Requires Senior Approval',
      type: 'checkbox',
      style: { width: '80px' },
      classNames: {
        header: 'cell-align-center',
        column: 'cell-align-center',
      },
      deriveValue: (row) => getRequiresSeniorApproval(row, seniorApprovalLimit),
    },
    {
      id: 'claim_status',
      header: 'Claim Status',
      type: 'custom',
      style: { width: '130px' },
      component: ClaimStatusBadge,
    },
    {
      id: 'status',
      header: 'Status',
      type: 'custom',
      component: StatusBadge,
    },
    {
      id: 'action_required',
      header: 'Action Required?',
      type: 'custom',
      style: { width: '300px' },
      component: ActionButtons,
      componentProps: {
        getRequiresSeniorApproval: (row: Row) => getRequiresSeniorApproval(row, seniorApprovalLimit),
      },
    },
  ];

  return columns;
};
